<template>
    <div v-if="!libraryCoach" class="gate-wrap">
        <coach-required />
    </div>
    <statistics-view v-else :key="libraryCoach.id" />
</template>

<script>

import { mapState } from "vuex";
import StatisticsView from "@/views/coach/Statistics";
import CoachRequired from "@/components/company/CoachRequired";

export default {
    name: "CompanyStatistics",
    components: { StatisticsView, CoachRequired },
    computed: {
        ...mapState(['libraryCoach']),
    },
}
</script>

<style scoped>
.gate-wrap {
    padding: 12px;
}
</style>
